import axios from 'axios'
import config from 'config'

import { defaultLosJsonHeaders } from '../requestHeaders'

export interface ApplicationRoutingRecord {
    routingId: number
    applicationId: number
    provider: string | null
    portal: string | null
    dealerWebAppUrl: string | null
    redirectUrl: string | null
    reason: string
    isCurrent: boolean
    created: string
}

export default async function getApplicationRouting(
    applicationId: string,
): Promise<ApplicationRoutingRecord | null> {
    const response = await axios.get<ApplicationRoutingRecord[]>(
        `${config.API_BASE_URL}/api/v3/applications/${applicationId}/routing/`,
        {
            withCredentials: true,
            headers: defaultLosJsonHeaders(),
        },
    )

    return response.data.find((r) => r.isCurrent) ?? response.data[0] ?? null
}
